'kiwi public';

import getState from '@/libs/state';
var avatarPositions = [45, 135, 225, 315];
export function getAvatarTransform() {
  var position = getState().setting('avatars.away_status_position');
  var angle = avatarPositions[position - 1] || 45;
  return "rotate(".concat(angle, " 50 50)");
}
export default {
  computed: {
    awayStatusTransform: getAvatarTransform
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserAvatarCommon"]
window._kiwi_exports.components.UserAvatarCommon = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
